export default "__VITE_ASSET__BKRUWi7Z__"